import { render, staticRenderFns } from "./linklogin.vue?vue&type=template&id=051c82bb&"
import script from "./linklogin.vue?vue&type=script&lang=js&"
export * from "./linklogin.vue?vue&type=script&lang=js&"
import style0 from "./linklogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports